import { useAuth } from '../auth/AuthContext';

/**
 * Landing page after login. Greets the user and surfaces their role
 * so the operator can confirm the right account is active before
 * touching destructive admin pages.
 */
export function Dashboard(): JSX.Element {
  const { user } = useAuth();
  const name = user?.displayName ?? user?.email ?? 'ゲスト';
  return (
    <div>
      <h1 className="text-2xl font-bold">{name} さん、ようこそ</h1>
      <p className="mt-2 text-sm text-gray-600">
        権限: <span className="font-medium">{user?.role ?? '未設定'}</span>
      </p>
    </div>
  );
}
